import { atom } from "jotai";

export const coachAtom = atom({
  loggedin: false,
  name: "",
  email: ""
});
